// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"665":"90d92edf","787":"ee4fe4bd"}[chunkId] + ".chunk.js";
};